<template>
  <div id="app">
  
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.15.1/css/all.css"
      integrity="sha384-vp86vTRFVJgpjF9jiIGPEEqYqlDwgyBgEF109VFjmqGmIY/Y4HV4d3Gp2irVfcrp"
      crossorigin="anonymous"
    />
    <Navbar/>
    <router-view :keep-alive="true" />
    <CakiACS/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import CakiACS from '@/components/footerACS'
export default {
  name: "app",
   components: {
    Navbar, CakiACS,
  }
};
</script>

<style lang="scss">
@import "./App.scss";
</style>
